import MasterService from "./MasterService";

const CommonService = {
    ...MasterService,

    getDashboardCount() {
        return this.post('/lead/dashboardCount');
    },
    updateMasterRates(params: object) {
        return this.post('/common/updateMasterRates', params)
    },
    fetchMasterRates(params: object) {
        return this.post('/common/fetchMasterRates', params)
    },
    importCsv(params: object) {
        return this.post('/mmv/uploadCsv', params)
    },
    uploadAddOnCsv(params: object) {
        return this.post('/upload/uploadAddOnCsv', params)
    },
    getDocumentList(params: object) {
        return this.post('/common/document_list', params)
    },
    // getStateCityList() {
    //     return this.get('/common/cityStateList');
    // },
    // getlocalityList(params: object) {
    //     return this.post('/common/getlocality',params);
    // },
    addDocument(params: object) {
        return this.post('/lead/addDocumentWeb',params);
    },
    // getStateWiseCity() {
    //     return this.get('/common/getStateWiseCity')
    // }, 
    getMMVList(params: object) {
        return this.post('/mmv/getMMV', params)
    },
    getMMVListV1(params: object) {
        return this.post('/agency/api/getMMV', params)
    },
    fetchBaseIssueRate(params: object) {
        return this.post('/common/getBaseRate', params)
    },
    getDealersList() {
        return this.get('/common/dealersList');
    },
    getSfaUserByRole(params: object) {
        return this.post('/common/getSfaUsersByRole', params)
    },
    bankList() {
        return this.get('/agency/bankList')
    },
    fetchTraRates(params: object) {
        return this.post('/common/fetchTraData', params)
    },
    getDataFromDocument(params: object) {
        return this.post('/common/uploadAndReadDocument', params)
    },
    // getDistrictList(params: object) {
    //     return this.post('/common/getDistrict',params);
    // },
    getDocUploadUrl(params: object){
        return this.post('/agency/api/uploadLeadDocImagesId',params);
    },
    getVehicleAge(params: object){
        return this.post('/ruleEngine/getVehicleAge',params);
    },

    saveVehicleAge(params: object) {
        return this.post('/ruleEngine/saveVehicleAge', params)
    },
    getShortFileUrl(params: object) {
        return this.post('/common/getShortFileUrl', params)
    },
    getBrandList(params: object){
        return this.post('/mmv/getBrandList',params);
    },
    getParentModelList(params: object){
        return this.post('/mmv/getParentModelList',params);
    },
    getVersionList(params: object){
        return this.post('/mmv/getVersionList',params);
    },
    getLocalityList(params: object) {
        return this.post('/common/getLocalityList',params)
    },
    getCityList(params: object) {
        return this.post('/common/getCityList',params)
    }, 
    getStateList() {
        return this.post('/common/getStateList')
    }
}

export default CommonService
